import { useState } from 'react';
import { Building2, ListTree, Tags, Award, TrendingUp, TrendingDown, Settings, Clock, Layers } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader.jsx';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/Dialog.jsx';
import CompanySettingsPage from './CompanySettingsPage.jsx';
import DepartmentsPage from './DepartmentsPage.jsx';
import DesignationsPage from './DesignationsPage.jsx';
import PayGradesPage from './PayGradesPage.jsx';
import SalaryComponentsPage from './SalaryComponentsPage.jsx';
import TaxTablesPage from './TaxTablesPage.jsx';
import ShiftsPage from './ShiftsPage.jsx';
import EmployeeCategoriesPage from './EmployeeCategoriesPage.jsx';

const AllowancesPage = () => <SalaryComponentsPage type="allowance" />;
const DeductionsPage = () => <SalaryComponentsPage type="deduction" />;

const CARDS = [
  { key: 'company',           label: 'Company',           icon: Building2, description: 'Company profile & settings',      component: CompanySettingsPage,  size: 'xl'   },
  { key: 'departments',       label: 'Departments',       icon: ListTree,  description: 'Manage departments',              component: DepartmentsPage,      size: 'lg'   },
  { key: 'designations',      label: 'Designations',      icon: Tags,      description: 'Job titles & roles',              component: DesignationsPage,     size: 'lg'   },
  { key: 'pay-grades',        label: 'Pay Grades',        icon: Award,     description: 'Salary bands & grades',           component: PayGradesPage,        size: 'lg'   },
  { key: 'allowances',        label: 'Allowances',        icon: TrendingUp,   description: 'Earning allowance components',     component: AllowancesPage,  size: 'xl' },
  { key: 'deductions',        label: 'Deductions',        icon: TrendingDown, description: 'Deduction components',              component: DeductionsPage,  size: 'xl' },
  { key: 'tax-tables',        label: 'Tax Tables (APIT)', icon: Settings,  description: 'APIT tax slabs',                  component: TaxTablesPage,        size: 'xl'   },
  { key: 'shifts',               label: 'Shifts',               icon: Clock,   description: 'Work shift schedules',                component: ShiftsPage,               size: 'xl'   },
  { key: 'employee-categories',  label: 'Employee Categories',  icon: Layers,  description: 'Employee classification categories',  component: EmployeeCategoriesPage,   size: 'lg'   },
];

export default function MasterDetailsHub() {
  const [active, setActive] = useState(null);

  const activeCard = CARDS.find((c) => c.key === active);

  return (
    <div className="space-y-6">
      <PageHeader title="Master Details" description="Core configuration — company, structure, grades & components" />

      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2">
        {CARDS.map(({ key, label, icon: Icon, description }) => (
          <button
            key={key}
            type="button"
            onClick={() => setActive(key)}
            title={description}
            className="group flex flex-col items-center gap-2 rounded-xl p-3 text-center transition-all hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-600 dark:bg-brand-500 text-white shadow-sm group-hover:bg-brand-700 dark:group-hover:bg-brand-400 transition-colors">
              <Icon className="h-5 w-5" />
            </span>
            <span className="text-xs font-medium text-slate-700 dark:text-slate-300 leading-tight line-clamp-2 w-full">{label}</span>
          </button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(v) => !v && setActive(null)}>
        <DialogContent size={activeCard?.size ?? 'xl'}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {activeCard && <activeCard.icon className="h-5 w-5 text-brand-600" />}
              {activeCard?.label}
            </DialogTitle>
          </DialogHeader>
          {activeCard && <activeCard.component />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
